import React from 'react';
import { Box, Button, Menu, MenuItem, InputAdornment, IconButton } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PageHeader from 'components/Header/Page';
import CustomTextField from 'components/Inputs/CustomTextField';
import { Search } from '@mui/icons-material';
import VersionToggle from 'components/landingScreen/toggle';
import IBPFilters from './IBPFilters';
import { FilterIcon } from 'components/CommonIcons/Icons';
import colors from 'assets/theme/base/colors';
import { getBackgroundSx, getSearchInputLabelProps, searchInputSx } from './DataPipelineHelper';

type DataPipelineHeaderProps = {
  title: string;
  icon?: any;
  lastSync?: string;
  isDataRefresh?: boolean;
  isAllowed: boolean;
  anchorEl: HTMLElement | null;
  open: boolean;
  onDropdownClick: (event: React.MouseEvent<HTMLElement>) => void;
  onDropdownClose: () => void;
  onCreateClick: () => void;
  onExecutiveTemplate: () => void;
  buttonLabel: string;
  showSearch?: boolean;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  showIbpFilters?: boolean;
  onIbpFiltersChange?: (values: Record<string, string>) => void;
  showVersionToggle?: boolean;
  showUploadAction?: boolean;
  onUploadClick?: () => void;
  onFilterIconClick?: (e?: any) => void;
};

const DataPipelineHeader = ({
  title,
  icon,
  lastSync,
  isDataRefresh,
  isAllowed,
  anchorEl,
  open,
  onDropdownClick,
  onDropdownClose,
  onCreateClick,
  onExecutiveTemplate,
  buttonLabel,
  showSearch = false,
  searchValue = '',
  onSearchChange,
  showIbpFilters = false,
  onIbpFiltersChange,
  showVersionToggle = false,
  showUploadAction = false,
  onUploadClick,
  onFilterIconClick,
}: DataPipelineHeaderProps) => {
  return (
    <PageHeader title={title} icon={icon} lastSync={lastSync} isDataRefresh={isDataRefresh}>
      {showSearch && onSearchChange && (
        <CustomTextField
          className="search-prgm"
          placeholder="Search Programs"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{
            marginTop: '3px',
            backgroundColor: `${colors.search.background} !important`,
            borderRadius: '5px',
            zIndex: '99',
          }}
          sx={getBackgroundSx(colors)}
          InputLabelProps={getSearchInputLabelProps(colors)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: 'white.main' }} />
              </InputAdornment>
            ),
            sx: searchInputSx,
          }}
        />
      )}

      {showIbpFilters && onIbpFiltersChange && (
        <Box sx={{ width: { xs: '100%', md: 'auto' }, minWidth: 0 }}>
          <IBPFilters onChange={onIbpFiltersChange} />
        </Box>
      )}

      {onFilterIconClick && (
        <IconButton onClick={onFilterIconClick} aria-label="open-filters" sx={{ ml: 1 }}>
          <FilterIcon />
        </IconButton>
      )}

      {isAllowed && (
        <>
          <Button
            variant="pepwiseSecondary"
            onClick={onDropdownClick}
            sx={{ height: '43px' }}
            endIcon={<ArrowDropDownIcon />}
          >
            {buttonLabel}
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onDropdownClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            MenuListProps={{
              sx: {
                backgroundColor: '#009BD8 !important',
              },
            }}
            slotProps={{
              paper: {
                sx: {
                  borderRadius: '4px',
                  color: '#fff',
                  boxShadow: '0px 4px 16px rgba(0,0,0,0.3)',
                  mt: 0,
                },
              },
            }}
          >
            <MenuItem
              onClick={onCreateClick}
              sx={{
                color: '#fff',
                borderRadius: '4px',
                textTransform: 'uppercase',
                fontFamily: 'Montserrat',
                '&:hover': {
                  backgroundColor: '#005b99 !important',
                  color: '#fff',
                },
              }}
            >
              <Button variant="pepwiseButtonText">{buttonLabel}</Button>
            </MenuItem>
            <MenuItem
              onClick={onExecutiveTemplate}
              sx={{
                color: '#fff',
                borderRadius: '4px',
                textTransform: 'uppercase',
                fontFamily: 'Montserrat',
                '&:hover': {
                  backgroundColor: '#005b99 !important',
                  color: '#fff',
                },
              }}
            >
              <Button variant="pepwiseButtonText" disabled>
                EXECUTIVE TEMPLATE
              </Button>
            </MenuItem>
          </Menu>
        </>
      )}

      {showVersionToggle && <VersionToggle />}
    </PageHeader>
  );
};

export default DataPipelineHeader;
